module.exports = __webpack_public_path__ + "static/media/cloud.75931a7a.png";